import m from "../../geodata/es2015/northKoreaLow";
window.am4geodata_northKoreaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/northKoreaLow.js
// module id = null
// module chunks = 